<ng-container *transloco="let t" class="container">
  <div class="modal-body">
    <div class="d-flex align-items-center">
      <img src="assets/img/svg/T.svg" alt="Tracey logo">
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{ title ? t(title) : "" }}
        </div>
      </div>
      <div class="pe-20 align-self-start">
        <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
        </button>
      </div>
    </div>
    <div class="body-wrapper">
      <div class="d-flex flex-column align-items-center">
        <div class="py-4 w-100">
          <app-search-rounded [name]="filteredInput" [placeholder]="t('explore.search')"
                              (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
        </div>
        @if (filteredEvents && filteredEvents.length > 0) {
          <div class="ps-4 w-100">
            <div class="d-flex w-100 fw-bold list-title-underline">
              {{ tableColumnName ? t(tableColumnName) : "" }}
            </div>
            @for (event of filteredEvents;track event;let idx = $index) {
              <ng-container>
                <div class="d-flex w-100">
                  <div class="flex-grow-1 item-underline">
                    <app-language-output [hrLabel]="event.name" [enLabel]="event.nameEng"
                                         [itLabel]="event.nameIta" [srLabel]="event.nameSr" [bsLabel]="event.nameBs"
                                         [siLabel]="event.nameSlo" [defaultLanguage]="event.defaultLanguage"
                                         [languages]="languages"/>
                  </div>
                  <div class="item-underline">
                    <input class="form-check-input" type="checkbox"
                           [(ngModel)]="filteredEvents[idx].discountApplied"
                           (change)="onEventChange(event)">
                  </div>
                </div>
                @if (event.racesList && event.racesList.length > 0) {
                  <ng-container>
                    @for (race of event.racesList;track race;let jdx = $index) {
                      <div class="d-flex w-100">
                        <div class="flex-grow-1 item-underline">
                          <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng"
                                               [itLabel]="race.nameIta"
                                               [srLabel]="race.nameSr"
                                               [bsLabel]="race.nameBs"
                                               [siLabel]="race.nameSlo"
                                               [defaultLanguage]="event.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                        <div>
                          @if (raceCheckboxEnabled) {
                            <div class="item-underline">
                              <input class="form-check-input" type="checkbox"
                                     [(ngModel)]="filteredEvents![idx].racesList![jdx].discountApplied!"
                                     (change)="onRaceChange(event)">
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </ng-container>
                }
              </ng-container>
            }
          </div>
        } @else {
          <div class="px-3 px-lg-4 pt-4 pb-3">
            <app-empty-state [addPaddingBottom]="false"/>
          </div>
        }
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center pb-40-48">
      <div class="d-flex">
        <app-button (onClick)="onSave()" [label]="t('app.common.confirm')"
                    [btnClass]="'btn-primary-red text-uppercase'"></app-button>
      </div>
    </div>
  </div>
</ng-container>

